/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { StoreMenuPreSignedUrl } from '../models/store-menu-pre-signed-url';
import { StoreMenus } from '../models/store-menus';
import { storesStoreIdMenusGet } from '../fn/store-menus/stores-store-id-menus-get';
import { StoresStoreIdMenusGet$Params } from '../fn/store-menus/stores-store-id-menus-get';
import { storesStoreIdMenusMenuIdGet } from '../fn/store-menus/stores-store-id-menus-menu-id-get';
import { StoresStoreIdMenusMenuIdGet$Params } from '../fn/store-menus/stores-store-id-menus-menu-id-get';

@Injectable({ providedIn: 'root' })
export class StoreMenusService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storesStoreIdMenusMenuIdGet()` */
  static readonly StoresStoreIdMenusMenuIdGetPath = '/stores/{storeId}/menus/{menuId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdMenusMenuIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdMenusMenuIdGet$Response(params: StoresStoreIdMenusMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreMenuPreSignedUrl>> {
    return storesStoreIdMenusMenuIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdMenusMenuIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdMenusMenuIdGet(params: StoresStoreIdMenusMenuIdGet$Params, context?: HttpContext): Observable<StoreMenuPreSignedUrl> {
    return this.storesStoreIdMenusMenuIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreMenuPreSignedUrl>): StoreMenuPreSignedUrl => r.body)
    );
  }

  /** Path part for operation `storesStoreIdMenusGet()` */
  static readonly StoresStoreIdMenusGetPath = '/stores/{storeId}/menus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdMenusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdMenusGet$Response(params: StoresStoreIdMenusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreMenus>> {
    return storesStoreIdMenusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdMenusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdMenusGet(params: StoresStoreIdMenusGet$Params, context?: HttpContext): Observable<StoreMenus> {
    return this.storesStoreIdMenusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreMenus>): StoreMenus => r.body)
    );
  }

}
